import React from 'react';
import { ChevronLeft, ChevronRight, Check } from 'lucide-react';

interface V1SurveyNavigationProps {
  currentPage: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
  canGoBack?: boolean;
  canGoForward?: boolean;
  isLastPage?: boolean;
}

export const V1SurveyNavigation: React.FC<V1SurveyNavigationProps> = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  onSubmit,
  isSubmitting = false,
  canGoBack = true,
  canGoForward = true,
  isLastPage = false,
}) => {
  return (
    <div className="mt-8 border-t pt-6">
      {/* Progress indicator */}
      {totalPages > 1 && (
        <div className="mb-4">
          <div className="text-sm text-gray-600 mb-2">
            Page {currentPage} of {totalPages}
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${(currentPage / totalPages) * 100}%` }}
            />
          </div>
        </div>
      )}

      {/* Navigation buttons */}
      <div className="flex justify-between items-center">
        <div>
          {canGoBack && (
            <button
              type="button"
              onClick={onPrevious}
              className="inline-flex items-center px-4 py-2 text-gray-700 hover:text-gray-900"
            >
              <ChevronLeft className="h-4 w-4 mr-1" />
              Previous
            </button>
          )}
        </div>

        <div className="text-sm text-gray-500">
          {!isLastPage && (
            <span>Progress is not saved</span>
          )}
        </div>

        <div>
          {isLastPage ? (
            <button
              type="button"
              onClick={onSubmit}
              disabled={isSubmitting}
              className="inline-flex items-center px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full mr-2" />
                  Submitting...
                </>
              ) : (
                <>
                  <Check className="h-4 w-4 mr-2" />
                  Submit Survey
                </>
              )}
            </button>
          ) : (
            canGoForward && (
              <button
                type="button"
                onClick={onNext}
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Next
                <ChevronRight className="h-4 w-4 ml-1" />
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};